import {Popup} from "~components/popup/popup";

class Favorites {
	constructor() {
		this.initialize();
	}

	initialize() {
		let _this = this;

		/**
		 * Добавление в избранное
		 */
		$(document).on('click', '[data-favorites-add]', function(e) {
			let _element = $(this);

			if (_element.attr('href') !== '#') {
				return;
			}

			e.preventDefault();

			let productId = parseInt($(this).data('product-id'));
			let offerId = parseInt($(this).data('offer-id'));

			$('body').addClass('body--loading');

			$.ajax({
				url: '/local/ajax/favorites.php',
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'add',
					product_id: productId,
					offer_id: offerId,
				}
			}).done(function(data) {
				if (data.status === 'ok') {
					window.favorites = data.favorites;
					if(data.dataLayer){
					    dataLayer.push({
					        'event': 'add_to_wishlist',
					        'value': '',
					        'items': [data.dataLayer],
					    });
					}
					try {
                        ym(79276948, 'reachGoal', 'add_to_wishlist');
                    } catch(e) {}

					_this.changeLink(_element, true);

				} else {
					if (typeof window.Popup !== 'undefined') {
						window.Popup.message('Ошибка', data.message);
					}
				}

				$('body').removeClass('body--loading');

			}).fail(function () {
				$('body').removeClass('body--loading');
			});
		});

		/**
		 * Удаление из избранного
		 */
		$(document).on('click', '[data-favorites-delete]', function(e) {
			e.preventDefault();

			let _element = $(this);
			let card = _element.closest('[data-favorites-id]');

			let favoriteId = card.data('favorites-id');

			$('body').addClass('body--loading');

			$.ajax({
				url: '/local/ajax/favorites.php',
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'delete',
					favorite_id: favoriteId,
				}
			}).done(function(data) {
				if (data.status === 'ok') {
					window.favorites = data.favorites;

					card.remove();

					if (!$('[data-favorites-list] [data-favorites-id]').length) {
						$('[data-favorites-null]').removeClass('d-none');
					}

				} else {
					if (typeof window.Popup !== 'undefined') {
						window.Popup.message('Ошибка', data.message);
					}
				}

				$('body').removeClass('body--loading');
			}).fail(function () {
				$('body').removeClass('body--loading');
			});
		});

		/**
		 * Добавление в корзину
		 */
		$(document).on('click', '[data-favorites-buy]', function(e) {
			let _element = $(this);
			let offerId = _element.data('offer-id');
			let quantity = _element.closest('[data-favorites-id]').find('[data-favorites-quantity').val();

			if (typeof window.Basket !== 'undefined') {
				window.Basket.add(
					offerId,
					quantity,
					function(response) {
						if (typeof window.miniCart !== 'undefined') {
							window.miniCart.refreshMiniCart();
						}
					}
				);
			}
		});

		$(document).on('click', '[data-favorites-update]', function(e) {
			e.preventDefault();

			let _element = $(this);
			let form = _element.closest('form');

			let favoriteId = _element.data('favorites-id');
			let productId = form.find('input[data-product-id]').val();
			let offerId = form.find('input[data-sku-id]').val();

			$('body').addClass('body--loading');

			$.ajax({
				url: '/local/ajax/favorites.php',
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'update',
					favorite_id: favoriteId,
					product_id: productId,
					offer_id: offerId,
				}
			}).done(function(data) {
				if (data.status === 'ok') {
					window.favorites = data.favorites;

					let favoriteCard = $('[data-favorites-id="' + favoriteId + '"]');
					let newFavoriteId = $(data.html).data('favorites-id');

					favoriteCard.replaceWith(data.html);

					favoriteCard = $('[data-favorites-id="' + newFavoriteId + '"]');

					let img = favoriteCard.find('.lazyload');
					let lazy = new LazyLoad(img);
					lazy.loadImages();

					favoriteCard.find('[data-popup]').each(function(){
						let _popup = new Popup($(this));
						_popup.initPopup();
					});

					$.magnificPopup.close();
				} else {
					if (typeof window.Popup !== 'undefined') {
						window.Popup.message('Ошибка', data.message);
					}
				}

				$('body').removeClass('body--loading');
			}).fail(function () {
				$('body').removeClass('body--loading');
			});
		});
	}

	/**
	 * Изменение ссылки на добавление в избранное
	 * В соответстивии - добавлен ли уже товар или нет
	 *
	 * @param linkNode
	 * @param inFavorites
	 */
	changeLink(linkNode, inFavorites) {
		if (inFavorites) {
			linkNode
				.html('<i class="fa fa-heart"></i>&nbsp;Список желаний')
				.attr('href', '/personal/favorites/');
		} else {
			linkNode
				.html('<i class="fa fa-heart"></i>&nbsp;Добавить в список желаний')
				.attr('href', '#');
		}
	}

	/**
	 * Проверка на наличие товара в избранном
	 *
	 * @param productId
	 * @param offerId
	 *
	 * @returns {boolean}
	 */
	inFavorites(productId, offerId) {
		window.favorites = window.favorites || [];

		let isFound = false;

		window.favorites.forEach(function(favorite) {
			if (
				(favorite.PRODUCT_ID === productId)
				&& (favorite.OFFER_ID === offerId)
			) {
				isFound = true;

				return false;
			}
		});

		return isFound;
	}
}

window.Favorites = new Favorites();
